import entity from '../../../models/school/teachers'

export default [
  {
    path: '/teachers',
    meta: {
      entity,
      requiresPermissionTo: 'teachers',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/teachers/new',
    meta: {
      entity,
      requiresPermissionTo: 'teachers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/teachers/:id',
    meta: {
      entity,
      requiresPermissionTo: 'teachers',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
